import { render, staticRenderFns } from "./sky-testInput.vue?vue&type=template&id=306d4c6b&scoped=true"
import script from "./sky-testInput.vue?vue&type=script&lang=js"
export * from "./sky-testInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306d4c6b",
  null
  
)

export default component.exports